import { defineStore } from 'pinia';
import type { GarbageRegular } from '@/views/RegisterRegularGarbage/const';
export const useProjectRegularStore = defineStore({
  id: 'projectRegular',
  state: () => ({
    project: {} as GarbageRegular
  }),
  actions: {}
});
